import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { PressReleaseComponent } from './pages/press-release/press-release.component';
import { PressReleaseDetailsComponent } from './pages/press-release-details/press-release-details.component';
import { AwardRecognitionComponent } from './pages/award-recognition/award-recognition.component';
import { OurTeamComponent } from './pages/our-team/our-team.component';
import { OurEventsComponent } from './pages/our-events/our-events.component';
import { OurPartnersComponent } from './pages/our-partners/our-partners.component';
import { AdvisoryPanelComponent } from './pages/advisory-panel/advisory-panel.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { CareerAtComponent } from './pages/career-at/career-at.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ConsultancySolutionsComponent } from './pages/consultancy-solutions/consultancy-solutions.component';
import { TrainingVideosComponent } from './pages/training-videos/training-videos.component';
import { EventDetailsComponent } from './pages/event-details/event-details.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { EditProfileComponent } from './pages/edit-profile/edit-profile.component';
import { ChangePswdComponent } from './pages/change-pswd/change-pswd.component';
import { RegulatoryServiceComponent } from './pages/regulatory-service/regulatory-service.component';
import { OurStoryComponent } from './pages/our-story/our-story.component';
import { GallaryDetailComponent } from './pages/gallary-detail/gallary-detail.component';
import { ClientComponent } from './pages/client/client.component';
import { ResetPswdComponent } from './pages/reset-pswd/reset-pswd.component';
import { RegistrationPageComponent } from './pages/registration-page/registration-page.component';
import { DemoRequestComponent } from './pages/demo-request/demo-request.component';
import { EthicsComponent } from './components/ethics/ethics.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'about-us', component: AboutUsComponent },
    { path: 'advisory', pathMatch: 'full', component: AdvisoryPanelComponent },
    { path: 'awards-recognition', pathMatch: 'full', component: AwardRecognitionComponent },
    { path: 'career', pathMatch: 'full', component: CareerAtComponent },
    { path: 'change_password', component: ChangePswdComponent },
    { path: 'contact', pathMatch: 'full', component: ContactUsComponent },
    { path: 'demo_request', component: DemoRequestComponent },
    { path: 'edit_profile', component: EditProfileComponent },
    { path: 'events/:id', pathMatch: 'full', component: EventDetailsComponent },
    { path: 'gallery', pathMatch: 'full', component: GalleryComponent },
    { path: 'home', pathMatch: 'full', component: HomeComponent },
    { path: 'events', pathMatch: 'full', component: OurEventsComponent },
    { path: 'our-partners', pathMatch: 'full', component: OurPartnersComponent },
    { path: 'our-teams', pathMatch: 'full', component: OurTeamComponent },
    { path: 'patent-india', component: ConsultancySolutionsComponent },
    { path: 'press-release', pathMatch: 'full', component: PressReleaseComponent },
    { path: 'press_release_details/:id', pathMatch: 'full', component: PressReleaseDetailsComponent },
    { path: 'profile', component: ProfileComponent },
    { path: 'training-videos', component: TrainingVideosComponent },
    { path: 'agro-regulatory', component: RegulatoryServiceComponent },
    { path: 'our-story', component: OurStoryComponent },
    { path: 'clients', component: ClientComponent },
    { path: 'gallary_detail/:id', component: GallaryDetailComponent },
    { path: 'resetpswd', component: ResetPswdComponent },
    { path: 'registration', component: RegistrationPageComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'ethics', component: EthicsComponent }
]; 
